import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "button-spinner-wrapper" }

import CircleSpinner from '@/components/ui/CircleSpinner.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonSpinner',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CircleSpinner, {
      "animation-duration": 2000,
      size: 16,
      color: 'rgb(0,100,255)'
    })
  ]))
}
}

})